import { combineReducers } from 'redux'
import consultant from './consultant'
import lists from './lists'

export default combineReducers({
  consultant,
  lists
})
